import React from "react";

const Share = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.34034 3.67344V5.99906L6.41307 6.01617C4.64373 5.99038 3.39115 6.57817 2.53522 8.02791C1.90972 9.01988 2.00523 10.0299 2.00523 12.0068C2.00509 12.0123 2.01125 12.0158 2.01571 12.0126C3.08565 11.2345 4.24166 10.0196 6.46344 10.0196C6.99122 10.0196 7.85257 10.009 9.34034 10.009V12.3267C9.34034 12.3326 9.34727 12.3356 9.35154 12.3316L13.9979 8.00664C14.0007 8.004 14.0007 7.99949 13.9979 7.99685L9.35154 3.66855C9.34728 3.66458 9.34034 3.66761 9.34034 3.67344Z"
        stroke="white"
      />
    </svg>
  );
};

export default Share;
